/** @jsx jsx */
import { jsx, Box } from 'theme-ui'

const NavLink = props => {
  return (
    <Box
      as="li"
      sx={{
        color: 'inherit',
        display: ['block', 'block', 'inline-block'],
        fontFamily: 'body',
        px: 2,
        'a:hover': {
          textDecoration: 'none',
        },
      }}
      {...props}
    >
      {props.children}
    </Box>
  )
}

export default NavLink
